<template>
    <div class="sub-tabs">
        <b-tabs v-model="tabs"
                lazy
                fill
        >
            <b-tab title="Degradabilidad">
                <degradability v-if="tabs === 0"/>
            </b-tab>

            <b-tab title="Método sumatorio">
                <summation_method v-if="tabs === 1"/>
            </b-tab>

            <b-tab title="Factor M">
                <factor_m v-if="tabs === 2"/>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>

import factor_m from './factor_m.vue';
import degradability from './degradability.vue';
import summation_method from './summation_method/index.vue';

export default {
    name: 'index',
    components: {
        factor_m,
        degradability,
        summation_method
    },
    data() {
        return {
            tabs: 0
        };
    }
};
</script>

<style lang="scss"
       src="../../../../../assets/calculator.scss"
/>

